var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFabricacionDesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 162.5,
    height: 38,
    viewBox: "0 0 162.5 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Uni\\xF3n_6",
    x: 0,
    y: 0,
    width: 162.5,
    height: 38,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fabricacion",
    transform: "translate(-28 -322.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 28, 322.5)",
    filter: "url(#Uni\\xF3n_6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_6-2",
    "data-name": "Uni\\xF3n 6",
    d: "M-872.987-2056.5a14.5,14.5,0,0,1,14.5-14.5,14.452,14.452,0,0,1,10,4h119a10,10,0,0,1,10,10,10,10,0,0,1-10,10H-847.532a14.466,14.466,0,0,1-10.954,5A14.5,14.5,0,0,1-872.987-2056.5Z",
    transform: "translate(877.49 2073.5)",
    fill: "#9b2690"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_171374",
    "data-name": "Trazado 171374",
    d: "M4.676,5.117H3.808V4.13H2.954v.987h-1.6L3.626,2.1H2.653L.238,5.257v.63H2.926V7h.882V5.887h.868ZM10.92,2.863V2.1H7.343V7h.91V5.124h2.366v-.77H8.253V2.863Zm2.107.357a2.628,2.628,0,0,0-1.582.462l.343.637a1.851,1.851,0,0,1,1.134-.371c.623,0,.931.3.931.812v.056h-.966c-1.134,0-1.554.49-1.554,1.113,0,.651.539,1.12,1.393,1.12a1.325,1.325,0,0,0,1.176-.5V7h.826V4.809C14.728,3.731,14.1,3.22,13.027,3.22Zm-.119,3.192c-.448,0-.714-.2-.714-.518,0-.273.161-.5.756-.5h.9v.434A.953.953,0,0,1,12.908,6.412ZM17.92,3.22a1.554,1.554,0,0,0-1.2.5V1.806h-.875V7h.833V6.517a1.541,1.541,0,0,0,1.239.532,1.821,1.821,0,0,0,1.9-1.918A1.815,1.815,0,0,0,17.92,3.22Zm-.1,3.08a1.092,1.092,0,0,1-1.113-1.169,1.111,1.111,0,1,1,2.219,0A1.087,1.087,0,0,1,17.822,6.3Zm3.661-2.492V3.262H20.65V7h.875V5.187A1.019,1.019,0,0,1,22.61,4.032a1.111,1.111,0,0,1,.2.021V3.22A1.471,1.471,0,0,0,21.483,3.808ZM24,2.646a.537.537,0,0,0,.56-.546A.521.521,0,0,0,24,1.6a.526.526,0,1,0,0,1.05ZM23.555,7h.875V3.262h-.875Zm3.738.049a1.7,1.7,0,0,0,1.6-.875l-.672-.392a1.058,1.058,0,0,1-.931.518,1.093,1.093,0,0,1-1.134-1.169,1.1,1.1,0,0,1,1.134-1.169,1.058,1.058,0,0,1,.931.518l.672-.392a1.682,1.682,0,0,0-1.6-.868,1.917,1.917,0,1,0,0,3.829Zm3.78-3.829a2.628,2.628,0,0,0-1.582.462l.343.637a1.851,1.851,0,0,1,1.134-.371c.623,0,.931.3.931.812v.056h-.966c-1.134,0-1.554.49-1.554,1.113,0,.651.539,1.12,1.393,1.12a1.325,1.325,0,0,0,1.176-.5V7h.826V4.809C32.774,3.731,32.151,3.22,31.073,3.22Zm-.119,3.192c-.448,0-.714-.2-.714-.518,0-.273.161-.5.756-.5h.9v.434A.953.953,0,0,1,30.954,6.412Zm4.69.637a1.7,1.7,0,0,0,1.6-.875l-.672-.392a1.058,1.058,0,0,1-.931.518A1.093,1.093,0,0,1,34.5,5.131a1.1,1.1,0,0,1,1.134-1.169,1.058,1.058,0,0,1,.931.518l.672-.392a1.682,1.682,0,0,0-1.6-.868,1.917,1.917,0,1,0,0,3.829Zm2.793-4.4A.537.537,0,0,0,39,2.1a.521.521,0,0,0-.56-.5.526.526,0,1,0,0,1.05ZM38,7h.875V3.262H38ZM41.1,2.751h.756l1.218-.959H42.049Zm.6,4.3a1.885,1.885,0,0,0,1.995-1.918,1.993,1.993,0,0,0-3.983,0A1.887,1.887,0,0,0,41.7,7.049Zm0-.749a1.087,1.087,0,0,1-1.106-1.169,1.111,1.111,0,1,1,2.219,0A1.089,1.089,0,0,1,41.7,6.3Zm4.956-3.08a1.625,1.625,0,0,0-1.288.525V3.262h-.833V7h.875V5.11a.993.993,0,0,1,1.043-1.127c.56,0,.889.322.889.987V7h.875V4.858A1.461,1.461,0,0,0,46.655,3.22Z",
    transform: "translate(61.5 334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21911",
    "data-name": "Grupo 21911",
    transform: "translate(37.253 329.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_171075",
    "data-name": "Trazado 171075",
    d: "M18.46,7.965h-.91a7.75,7.75,0,0,0-.838-2.029l.641-.642a.655.655,0,0,0,0-.927L15.5,2.512a.655.655,0,0,0-.927,0l-.642.641A7.761,7.761,0,0,0,11.9,2.315v-.91A.655.655,0,0,0,11.245.75H8.621a.655.655,0,0,0-.656.656v.91a7.761,7.761,0,0,0-2.028.838l-.642-.641a.655.655,0,0,0-.927,0L2.512,4.367a.655.655,0,0,0,0,.927l.641.642a7.759,7.759,0,0,0-.838,2.029h-.91a.656.656,0,0,0-.656.656v2.624a.656.656,0,0,0,.656.656h.91a7.757,7.757,0,0,0,.838,2.028l-.641.642a.656.656,0,0,0,0,.928l1.855,1.855a.655.655,0,0,0,.927,0l.642-.641a7.761,7.761,0,0,0,2.028.838v.91a.656.656,0,0,0,.656.656h2.624a.656.656,0,0,0,.656-.656v-.91a7.761,7.761,0,0,0,2.028-.838l.642.641a.655.655,0,0,0,.927,0L17.353,15.5a.656.656,0,0,0,0-.928l-.641-.642A7.749,7.749,0,0,0,17.55,11.9h.91a.655.655,0,0,0,.656-.656V8.621a.655.655,0,0,0-.656-.656m-4.591,3.279a1.3,1.3,0,0,1-.724,1.173L9.933,14.131,6.707,12.41A1.3,1.3,0,0,1,6,11.244V7.53a.656.656,0,0,1,.367-.589L9.346,5.48a1.313,1.313,0,0,1,1.174,0L13.5,6.953a.656.656,0,0,1,.366.588Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_171077",
    "data-name": "Trazado 171077",
    d: "M32.649,24.124l-2.624-1.312a.656.656,0,0,0-.587,0l-2.624,1.312a.686.686,0,0,0-.062.042l2.979,1.489,2.979-1.489a.725.725,0,0,0-.062-.042",
    transform: "translate(-19.799 -16.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_171079",
    "data-name": "Trazado 171079",
    d: "M25.492,34.393a.656.656,0,0,0,.363.587l2.589,1.381V32.628l-2.952-1.476Z",
    transform: "translate(-18.839 -23.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_171081",
    "data-name": "Trazado 171081",
    d: "M40.612,36.36,43.2,34.979a.656.656,0,0,0,.363-.587V31.152l-2.952,1.476Z",
    transform: "translate(-30.351 -23.148)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFabricacionDesk);
export default __webpack_public_path__ + "static/media/fabricacionDesk.8dec789666ee6fd2ec4c76cf298b738e.svg";
export { ForwardRef as ReactComponent };